/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList, useRefresh, RefreshIconButton, ResourceContextProvider, Button as RaButton
} from 'react-admin';
import {
    useMediaQuery, makeStyles, Button, Dialog, DialogContent, DialogActions, IconButton, ListItem, ListItemIcon, ListItemText,
    TextField as MuiTextField, Checkbox, Select, FormControl, MenuItem, Tooltip, DialogContentText, InputLabel, Typography, Switch, FormControlLabel, FormGroup
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { saveTokens } from './utils/saveTokens';
import CustomDateTimePicker from './components/CustomDateTimePickerV4';
import EmojiTransportationOutlinedIcon from "@material-ui/icons/EmojiTransportationOutlined";
import { stringify } from 'query-string';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';
import DownloadIcon from "@material-ui/icons/GetApp";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CustomFilter from './components/CustomFilter';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, TimePicker } from '@material-ui/pickers';
import CustomDeleteButton from './CustomDeleteButton';
import { Chip, DialogTitle } from '@mui/material';
import { withStyles } from '@material-ui/core';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import { KeyboardDatePicker } from "@material-ui/pickers";
import ParkingSearchSelector from './components/ParkingSearchSelector';
import ReplayIcon from '@material-ui/icons/Replay';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 600
    },
    boldText: {
        fontFamily: "Poppins-SemiBold"
    },
    lightText: {
        fontFamily: "Poppins-Regular"
    },
    tooltip: {
        fontFamily: "Poppins-Regular",
        fontSize: 12,
        letterSpacing: "0.04em"
    },
    autocomplete: {
        '& .MuiAutocomplete-inputRoot': {
            height: '44px',
            '& .MuiChip-root': {
                marginTop: '-10px',
            },
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#C2CFE0'
            },
            '&:hover fieldset': {
                borderColor: '#C2CFE0'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#C2CFE0'
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            outline: 'none'
        },
    },
    formControl: {
        '& .MuiSelect-select': {
            height: '23px',
            fontSize: 12,
            color: "#AAAAAA"
        },
        '& .MuiInputLabel-root': {
            color: '#C2CFE0',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2CFE0',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2CFE0',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2CFE0',
        }
    },
    textField: {
        '& .MuiOutlinedInput-root': {
          height: '44px',
          '& fieldset': {
            borderColor: '#C2CFE0',
          },
          '&:hover fieldset': {
            borderColor: '#C2CFE0',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#C2CFE0',
          },
        },
      },
});
const CATEGORY = "REPORTS";
const REPORT_FORMATS = [
    { value: "xlsx", label: "Excel" },
    { value: "pdf", label: "PDF" },
];
const REPORT_STATUS_COLORS = {
    INITIATED: "#109cf1",
    PROCESSING: "#e99100",
    COMPLETED: "#18cc69",
    ERROR: "#de575e"
};
const renderTime = time => moment(time).format("Do MMM YYYY, hh:mm A");

const HIDE_TIME_PERIOD = ["PERMIT_USERS", "MONTHLY_PASS_USERS"]

const fomattingFilter = (filterList) => {
    const result = {};
    if (filterList) {
        for (const obj of filterList) {
            const { filterType, value, id } = obj;
            if (value && id) result[filterType.replaceAll(" ", "_").toLowerCase()] = { value, id };
        }
    }
    return result;
}
const GENERATE_REPORTS = "GENERATE_REPORTS";
const SCHEDULED_REPORTS = "SCHEDULED_REPORTS";

export const Reports = props => {
    const generateReportTypes = [
        {
            type: "VEHICLE_SUMMARY", visible: sessionStorage.getItem('hide_parking_section') !== "1" || sessionStorage.getItem('vehicle_summary_name') === "Visitor Summary", filterTypesInitState: [
                {
                    filterType: "Action",
                    dataList: [{ name: "ENTERED", id: 1 }, { name: "EXITED", id: 2 }, { name: "NOT EXITED", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Category",
                    dataList: [{ name: "PAID", id: 1 }, { name: "DROP OFF", id: 2 }, { name: "FOC", id: 3 }, { name: "UNPAID", id: 4 }, { name: "DIGITAL PAYMENTS", id: 5 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
    
            ]
        },
        {
            type: "MONTHLY_PASS_PAYMENTS", visible: (sessionStorage.getItem('show_monthly_pass_log') === "1" && sessionStorage.getItem('show_monthly_pass') === "1"), filterTypesInitState: [
                {
                    filterType: "Vehicle",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log",
                    dataList: [{ name: "ISSUE", id: 1 }, { name: "RECHARGE", id: 2 }, { name: "APPROVAL", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "MONTHLY_PASS_LOGS", visible: (sessionStorage.getItem('show_monthly_pass_log') === "1" && sessionStorage.getItem('show_monthly_pass') === "1"), filterTypesInitState: [
                {
                    filterType: "Vehicle",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log",
                    dataList: [{ name: "ENTER", id: 4 }, { name: "EXIT", id: 5 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "PERMIT_LOGS", visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_logs') === "1", filterTypesInitState: [
                {
                    resourcePath: "rfidOrganization",
                    filterType: "Organization",
                    dataList: [],
                    searchList: [],
                    listType: "Dynamic",
                    resourceParam: "name",
                    source: "organization",
                    showFilter: true
                },
                {
                    filterType: "Vehicle Type",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Action",
                    dataList: [{ name: "ENTRY", id: 2 }, { name: "EXIT", id: 3 }, { name: "RAMP ENTRY", id: 4 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log By",
                    dataList: [{ name: "ANPR", id: 1 }, { name: "NON-ANPR", id: 2 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "PERMIT_PAYMENTS", visible: (sessionStorage.getItem("show_validity_column") === "1" && sessionStorage.getItem("show_rfid_payments") === "1"), filterTypesInitState: [
                {
                    resourcePath: "rfidOrganization",
                    filterType: "Organization",
                    dataList: [],
                    searchList: [],
                    listType: "Dynamic",
                    resourceParam: "name",
                    source: "organization",
                    showFilter: true
                },
                {
                    filterType: "Vehicle",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Action",
                    dataList: [{ name: "ISSUE", id: 2 }, { name: "RECHARGE", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "VISITOR_LOGS", visible: sessionStorage.getItem('show_visitor_logs') === "1", filterTypesInitState: [
                {
                    filterType: "Log By",
                    dataList: [{ name: "ANPR", id: 1 }, { name: "NON-ANPR", id: 2 }, { name: "BOTH JOINT", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log Type",
                    dataList: [{ name: "ENTRY", id: 1 }, { name: "EXIT", id: 2 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "OCCUPANCY", visible: sessionStorage.getItem('show_floor_occupancy') === "1"
        },
        {
            type: "PERMIT_SLOTS", visible: sessionStorage.getItem('show_permit_apartments') === "1", filterTypesInitState: [
                {
                    resourcePath: "slotAreas",
                    filterType: "Slot Area",
                    dataList: [],
                    searchList: [],
                    listType: "Dynamic",
                    resourceParam: "name",
                    source: "slot_area",
                    showFilter: true
                },
                {
                    filterType: "Flat & Tower",
                    dataList: [{ name: "Assigned", id: 2 }, { name: "Empty", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Vehicle",
                    dataList: [ { name: "Bike", id: 2 }, { name: "Car", id: 4 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
            ]
        },
    ];
    
    const scheduleReportTypes = [
        {
            type: "VEHICLE_SUMMARY", visible: sessionStorage.getItem('hide_parking_section') !== "1" || sessionStorage.getItem('vehicle_summary_name') === "Visitor Summary", filterTypesInitState: [
                {
                    filterType: "Action",
                    dataList: [{ name: "ENTERED", id: 1 }, { name: "EXITED", id: 2 }, { name: "NOT EXITED", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Category",
                    dataList: [{ name: "PAID", id: 1 }, { name: "DROP OFF", id: 2 }, { name: "FOC", id: 3 }, { name: "UNPAID", id: 4 }, { name: "DIGITAL PAYMENTS", id: 5 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
    
            ]
        },
        {
            type: "MONTHLY_PASS_PAYMENTS", visible: (sessionStorage.getItem('show_monthly_pass_log') === "1" && sessionStorage.getItem('show_monthly_pass') === "1"), filterTypesInitState: [
                {
                    filterType: "Vehicle",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log",
                    dataList: [{ name: "ISSUE", id: 1 }, { name: "RECHARGE", id: 2 }, { name: "APPROVAL", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "MONTHLY_PASS_LOGS", visible: (sessionStorage.getItem('show_monthly_pass_log') === "1" && sessionStorage.getItem('show_monthly_pass') === "1"), filterTypesInitState: [
                {
                    filterType: "Vehicle",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log",
                    dataList: [{ name: "ENTER", id: 4 }, { name: "EXIT", id: 5 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "PERMIT_LOGS", visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_logs') === "1", filterTypesInitState: [
                {
                    resourcePath: "rfidOrganization",
                    filterType: "Organization",
                    dataList: [],
                    searchList: [],
                    listType: "Dynamic",
                    resourceParam: "name",
                    source: "organization",
                    showFilter: true
                },
                {
                    filterType: "Vehicle Type",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Action",
                    dataList: [{ name: "ENTRY", id: 2 }, { name: "EXIT", id: 3 }, { name: "RAMP ENTRY", id: 4 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log By",
                    dataList: [{ name: "ANPR", id: 1 }, { name: "NON-ANPR", id: 2 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "PERMIT_PAYMENTS", visible: (sessionStorage.getItem("show_validity_column") === "1" && sessionStorage.getItem("show_rfid_payments") === "1"), filterTypesInitState: [
                {
                    resourcePath: "rfidOrganization",
                    filterType: "Organization",
                    dataList: [],
                    searchList: [],
                    listType: "Dynamic",
                    resourceParam: "name",
                    source: "organization",
                    showFilter: true
                },
                {
                    filterType: "Vehicle",
                    dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Action",
                    dataList: [{ name: "ISSUE", id: 2 }, { name: "RECHARGE", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "VISITOR_LOGS", visible: sessionStorage.getItem('show_visitor_logs') === "1", filterTypesInitState: [
                {
                    filterType: "Log By",
                    dataList: [{ name: "ANPR", id: 1 }, { name: "NON-ANPR", id: 2 }, { name: "BOTH JOINT", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Log Type",
                    dataList: [{ name: "ENTRY", id: 1 }, { name: "EXIT", id: 2 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                }
    
            ]
        },
        {
            type: "OCCUPANCY", visible: sessionStorage.getItem('show_floor_occupancy') === "1"
        },
        {
            type: "PERMIT_SLOTS", visible: sessionStorage.getItem('show_permit_apartments') === "1", filterTypesInitState: [
                {
                    resourcePath: "slotAreas",
                    filterType: "Slot Area",
                    dataList: [],
                    searchList: [],
                    listType: "Dynamic",
                    resourceParam: "name",
                    source: "slot_area",
                    showFilter: true
                },
                {
                    filterType: "Flat Tower",
                    dataList: [{ name: "Assigned", id: 2 }, { name: "Empty", id: 3 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
                {
                    filterType: "Vehicle Type",
                    dataList: [ { name: "Bike", id: 2 }, { name: "Car", id: 4 }],
                    listType: "Static",
                    caseType: "Static",
                    showFilter: true
                },
            ]
        },  
    ];
    
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [currentTab, setCurrentTab] = React.useState(GENERATE_REPORTS);

    const REPORT_TYPES = currentTab === GENERATE_REPORTS ? generateReportTypes : scheduleReportTypes
    const FREQUENCY_TYPES = [
        { type: 'Daily', visible: true },
        { type: 'Weekly', visible: true },
        { type: 'Monthly', visible: true },
    ];
    const DAYS_OF_WEEK = [
        'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'
    ];

    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "";
    const [search, setSearch] = useState(prevSearch.inputSearch);
    let searchTypeState = ["Report Type"];
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : searchTypeState[0]);

    const [selectedParkings, setSelectedParkings] = useState();
    const [parkingSuggestions, setParkingSuggestions] = useState([]);
    const [loadingParkings, setLoadingParkings] = useState(false);
    const [searchParkingFilter, setSearchParkingFilter] = useState("");
    const [allZones, setAllZones] = useState([]);
    const [selectedZones, setSelectedZones] = useState([]);
    const [zoneEditDialogVisible, setZoneEditDialogVisible] = useState(false);
    const [reportType, setReportType] = useState(REPORT_TYPES.filter(type => type.visible)[0]);

    const fetchParkingTimeout = useRef(null);

    const [startDateTime, setStartDateTime] = useState(moment().set({ hours: 0, minutes: 0, seconds: 0 }).toDate());
    const [endDateTime, setEndDateTime] = useState(moment().set({ hours: 23, minutes: 59, seconds: 59 }).toDate());

    const [requestReportLoading, setRequestReportLoading] = useState(false);

    const filter = { start_ime: startDateTime && !HIDE_TIME_PERIOD.includes(reportType.type) ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : null, end_time: endDateTime && !HIDE_TIME_PERIOD.includes(reportType.type) ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : null, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" } };

    const [filterListValue, setFilterListValue] = useState(null)
    const filterTypesInitState = reportType['filterTypesInitState']
    // const [selectedFormats, setSelectedFormats] = useState([]);
    const [selectedFormat, setSelectedFormat] = useState(null);
    const [selectedMultipleFormat, setSelectedMultipleFormat] = useState([]);
    const [frequencyType, setFrequencyType] = useState(FREQUENCY_TYPES[0]);
    const [selectedDay, setSelectedDay] = useState(DAYS_OF_WEEK[0]);
    const [selectedDate, setSelectedDate] = useState(1);
    const [selectedTime, setSelectedTime] = useState(moment().set({ hours: 0, minutes: 0, seconds: 0 }).toDate());
    const [showStartTime, setShowStartTime] = useState(null);
    const [showEndTime, setShowEndTime] = useState(null);
    const inputRef = useRef(null);
    const [newEmail, setNewEmail] = useState('');
    const [emailList, setEmailList] = useState([]);
    const [maxEmails] = useState(3);

    const handleTimeChange = (newTime) => {
        // Keep the date the same, update only the time
        const updatedTime = new Date(selectedTime);
        updatedTime.setHours(newTime.getHours());
        updatedTime.setMinutes(newTime.getMinutes());
        setSelectedTime(updatedTime);
        setShowStartTime(moment(updatedTime).format('ddd MMM DD YYYY hh:mm:ss A'));
    };

    const handleReportFormatChange = (value) => {
        setSelectedFormat(value === selectedFormat ? null : value);
    };

    const handleMultipleReportFormatChange = (formatValue) => {
        if (selectedMultipleFormat.includes(formatValue)) {
            setSelectedMultipleFormat(selectedMultipleFormat.filter(format => format !== formatValue));
        } else {
            setSelectedMultipleFormat([...selectedMultipleFormat, formatValue]);
        }
    };

    const generateNumbersArray = (start, end) => {
        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    };
    const datesArray = generateNumbersArray(1, 31);

    const handleDayChange = (event) => {
        setSelectedDay(event.target.value);
    }
    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    const reportParams = {
        access_key_ids: selectedZones.length !== 0 ? selectedZones.map(zone => zone.id) : undefined,
        report_name: reportType.type,
        report_format: selectedFormat,
        start_time: moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"),
        end_time: moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"),
        filters: filterListValue ? fomattingFilter(filterListValue) : undefined
    };

    const handleParkingFilterChange = (event, value) => {
        setSearchParkingFilter(value);
    };

    const fetchParkings = () => {
        setLoadingParkings(true);
        var params = {
            user_id: sessionStorage.getItem("user_id"),
            filter: JSON.stringify({ name: searchParkingFilter, includeSocieties: true }),
            page: 1,
            perPage: 10
        }
        fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response);
                return response.json();
            })
            .then((responseJson) => {
                setLoadingParkings(false);
                if (responseJson.success) {
                    setParkingSuggestions(selectedParkings ? responseJson.data.filter(val => !selectedParkings.map(selected => selected.id).includes(val.id)) : responseJson.data);
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                console.log(e)
                setLoadingParkings(false);
                notify('Error fetching Parkings', 'warning')
            });
    };

    const closeZoneEditDialog = () => {
        setZoneEditDialogVisible(false);
    };

    const selectAllZones = () => {
        const selectedValue = !(selectedZones.length === allZones.length);
        const zones = allZones.map(zone => ({
            ...zone,
            selected: selectedValue
        }));
        setAllZones(zones);
        setSelectedZones(selectedValue ? zones : []);
    };

    const toggleZoneSelection = (zone, index) => {
        const selectedValue = !(allZones[index].selected !== false);
        const zones = [...allZones];
        zones[index] = {
            ...zones[index],
            selected: selectedValue
        };
        setAllZones(zones);
        setSelectedZones(zones.filter(zone => zone.selected !== false));
    };

    const generateReport = () => {
        if (selectedZones.length === 0) {
            notify("1 Parking Zone must be selected", "warning");
            return;
        }
        setRequestReportLoading(true);
        fetch(`${config.HOST_NAME}/crm/requestReport`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(reportParams)
        })
            .then(response => {
                saveTokens(response);
                return response.json();
            })
            .then((responseJson) => {
                setRequestReportLoading(false);
                if (responseJson.success) {
                    notify("Request to generate report has been sent. Report should be available to download shortly, from the below table.", "success");
                    refresh();
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setRequestReportLoading(false);
                notify("Error Generating Report", "warning");
            });
    };

    const scheduleReportParams = {
        access_key_ids: selectedZones.length !== 0 ? selectedZones.map(zone => zone.id) : undefined,
        report_name: reportType.type,
        report_formats: selectedMultipleFormat,
        emails: emailList,
        frequency: frequencyType.type,
        start_time: moment(selectedTime).format("HH:mm"),
        ...(frequencyType.type === "Weekly" ? { start_day_of_week: selectedDay } : {}),
        ...(frequencyType.type === "Monthly" ? { start_date: selectedDate } : {}),
        filters: filterListValue ? fomattingFilter(filterListValue) : undefined
    };


    const scheduleReport = () => {
        if (emailList.length === 0) {
            notify("Atlease add 1 email Id", "warning");
            return;
        }
        if (selectedZones.length === 0) {
            notify("Atlease 1 Parking Zone must be selected", "warning");
            return;
        }
        // if (selectedFormats.length === 0) {
        //     notify("Atleast 1 Report Format should be selected", "warning");
        //     return;
        // }
        setRequestReportLoading(true);
        fetch(`${config.HOST_NAME}/crm/scheduleReport`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(scheduleReportParams)
        })
            .then(response => {
                return response.json();
            })
            .then((responseJson) => {
                setRequestReportLoading(false);
                if (responseJson.success) {
                    notify(responseJson.message, "success");
                    refresh();
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setRequestReportLoading(false);
                notify("Error Scheduling Report", "warning");
            });
    };

    const download = (url) => {
        const tempLinkElement = document.createElement('a');
        tempLinkElement.target = "_blank";
        tempLinkElement.href = url;
        let filename;
        if (typeof url === "string") {
            const urlKeys = url.split("/");
            filename = urlKeys[urlKeys.length - 1];
        } else {
            filename = "Download";
        }
        tempLinkElement.setAttribute('download', filename);
        tempLinkElement.click();
    };

    const handleInputChange = (event) => {
        setNewEmail(event.target.value);
    };
    const isValidEmail = (email) => {
        // Regular expression for email validation
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailRegex.test(email);
    };
    const handleInputKeydown = (event) => {
        if (event.key === 'Enter' && newEmail.trim() !== '') {
            setEmailList([...emailList, newEmail]);
            setNewEmail('');
        }
    };
    const handleBlur = () => {
        // if (newEmail && isValidEmail(newEmail) &&  emailList.length < maxEmails){
        //     if (emailList.includes(newEmail)) {
        //         notify('Email is already added', 'warning');
        //         setNewEmail('');
        //     } else {
        //         setEmailList([...emailList, newEmail]);
        //         setNewEmail('');
        //     }
        // }
        // else{
        //     notify('Invalid email', 'warning');
        //     setNewEmail(''); // Clear the input field when clicking outside.
        // }
        if (newEmail) {
            if (isValidEmail(newEmail) && emailList.length < maxEmails) {
                if (emailList.includes(newEmail)) {
                    notify('Email is already added', 'warning');
                    setNewEmail('');
                } else {
                    setEmailList([...emailList, newEmail]);
                    setNewEmail('');
                }
            } else {
                notify('Invalid email', 'warning');
                setNewEmail('');
            }
        }
        else {
            return;
        }
    };


    const addEmail = (event) => {
        if (newEmail && isValidEmail(newEmail) && emailList.length < maxEmails) {
            // Check if the email is already in the list
            if (emailList.includes(newEmail)) {
                notify('Email is already added', 'warning');
            } else {
                setEmailList([...emailList, newEmail]);
                setNewEmail('');
            }
        } else {
            notify('Invalid email or you can only add 3 emails', 'warning');
        }
    };

    const removeEmail = (emailToRemove) => {
        const updatedEmailList = emailList.filter((email) => email !== emailToRemove);
        setEmailList(updatedEmailList);
    };

    const renderField = (inputString) => {
        const fileExtensions = JSON.parse(inputString);
        return fileExtensions.join(', ');
    }

    const getArrayLength = (jsonStr) => {
        const jsonArray = JSON.parse(jsonStr);
        return jsonArray.length;
    };

    const convertTo12HourFormat = (apiTime) => {
        const parsedTime = new Date(`2023-01-01T${apiTime}`);
        const formattedTime = parsedTime.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
        return formattedTime;
    };

    useEffect(() => {
        if (frequencyType.type === 'Daily') {
            setShowStartTime(moment(selectedTime).format('ddd DD MMMM YYYY hh:mm:ss A'));
            setShowEndTime(moment(selectedTime).add(1, 'days').subtract(1, 'seconds').format('ddd DD MMMM YYYY hh:mm:ss A'));
        }
        if (frequencyType.type === 'Weekly') {
            setShowStartTime(moment(selectedTime).day(selectedDay).format('ddd MMM DD YYYY hh:mm:ss A'));
            setShowEndTime(moment(selectedTime).add(1, 'week').subtract(1, 'seconds').format('ddd MMM DD YYYY hh:mm:ss A'));
        }
        if (frequencyType.type === 'Monthly') {
            setShowStartTime(moment(selectedTime).date(selectedDate).format('MMM DD YYYY hh:mm:ss A'));
            setShowEndTime(moment(showStartTime).add(1, 'months').subtract(1, 'seconds').format('MMM DD YYYY hh:mm:ss A'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTime, frequencyType, selectedDate, showStartTime, selectedDay])

    useEffect(() => {
        eventTracker(CATEGORY, "REPORTS LIST");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (fetchParkingTimeout.current)
            clearTimeout(fetchParkingTimeout.current);
        fetchParkingTimeout.current = setTimeout(fetchParkings, 500);
    }, [searchParkingFilter]);  // eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div style={{ display: "flex", alignItems: "center", columnGap: 10, marginTop: 20, fontSize: 14, border: "none" }}>
            <div onClick={() => setCurrentTab(GENERATE_REPORTS)} style={{ borderBottom: currentTab === GENERATE_REPORTS ? "solid 3px #18cc69" : "#18cc69", color: currentTab === GENERATE_REPORTS ? "#18cc69" : "#6E6E6E", cursor: 'pointer', fontFamily: currentTab === GENERATE_REPORTS ? 'Poppins-Medium' : 'Poppins-Regular', fontSize: 14 }}>
                Generate Reports
            </div>
            {sessionStorage.getItem('role') === "admin" && <div onClick={() => setCurrentTab(SCHEDULED_REPORTS)} style={{ borderBottom: currentTab === SCHEDULED_REPORTS ? "solid 3px #18cc69" : "#18cc69", color: currentTab === SCHEDULED_REPORTS ? "#18cc69" : "#6E6E6E", cursor: 'pointer', fontFamily: currentTab === SCHEDULED_REPORTS ? 'Poppins-Medium' : 'Poppins-Regular', fontSize: 14 }}>
                Schedule Reports
            </div>}
        </div>
        {currentTab === GENERATE_REPORTS &&
            <ResourceContextProvider value="reports">
                <div>
                    <div className='reportsFieldLabels' style={{ marginTop: 10 }}>Select Site</div>
                    <div style={{ display: "flex", flexDirection: isSmallDevice ? "column" : "row", alignItems: isSmallDevice ? "flex-start" : "center", gap: 20, marginTop: 5 }}>
                        <Autocomplete
                            className={classes.autocomplete}
                            multiple
                            limitTags={4}
                            value={selectedParkings}
                            onChange={(event, parkings) => {
                                setSelectedParkings(parkings);
                                let zones = [];
                                for (let p of parkings) {
                                    zones = zones.concat(JSON.parse(p.zones_obj));
                                }
                                setAllZones(zones);
                                setSelectedZones(zones.filter(zone => zone.selected !== false));
                            }}
                            options={parkingSuggestions}
                            getOptionLabel={option => option.general_name}
                            //getOptionSelected={(option, value) => option.id === value.id}
                            disableCloseOnSelect
                            loading={loadingParkings}
                            noOptionsText="No Parkings Found"
                            onInputChange={handleParkingFilterChange}
                            renderInput={params => <MuiTextField {...params} variant="outlined" />}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.general_name}
                                </React.Fragment>
                            )}
                            style={{ flex: 1, width: "100%" }}
                        />

                        <div style={{ display: allZones.length > 0 ? "flex" : "none", alignItems: "center", gap: 10 }}>
                            <Button
                                onClick={() => setZoneEditDialogVisible(true)}
                                color="primary"
                                variant="contained"
                                style={{ textTransform: "none", fontSize: 12, fontFamily: "Poppins-SemiBold", letterSpacing: "0.06em", height: "42px", backgroundColor: "#18CC69", color: "#FFF", borderRadius: 5 }}
                                disableElevation
                                disabled={requestReportLoading}
                            >
                                <EditIcon style={{ fontSize: 14 }} />
                            </Button>
                        </div>

                        <Dialog fullWidth open={zoneEditDialogVisible} onClose={closeZoneEditDialog} scroll="paper" classes={{ paper: classes.dialogPaper }}>
                            <div style={{ fontFamily: "Poppins-Medium", fontSize: 18, color: "#222", padding: "10px 28px" }}>{selectedZones.length}/{allZones.length} Zones Selected</div>
                            <DialogContent dividers style={{ padding: 0 }}>
                                <ListItem key="select_all" button onClick={selectAllZones} style={{ padding: "4px 30px" }}>
                                    <ListItemIcon>
                                        <Checkbox
                                            edge="start"
                                            checked={selectedZones.length === allZones.length}
                                            disableRipple
                                        />
                                    </ListItemIcon>
                                    <ListItemText primary="Select All" classes={{ primary: classes.boldText }} />
                                </ListItem>
                                {allZones.map((zone, index) => (
                                    <ListItem key={zone.id} button onClick={() => toggleZoneSelection(zone, index)} style={{ padding: "4px 30px" }}>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={zone.selected !== false}
                                                disableRipple
                                            />
                                        </ListItemIcon>
                                        <ListItemText primary={zone.name} classes={{ primary: classes.lightText }} />
                                    </ListItem>
                                ))}
                            </DialogContent>
                            <DialogActions style={{ marginTop: 20 }}>
                                <Button
                                    onClick={closeZoneEditDialog}
                                    color="primary"
                                    variant="contained"
                                    style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18CC69", color: "#FFF" }}
                                    disableElevation
                                >
                                    Okay
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    <div style={{ display: "flex", flexDirection: isSmallDevice ? "column" : "row", alignItems: isSmallDevice ? "flex-start" : "center", gap: 20, marginTop: 10, flexWrap: "wrap" }}>
                        <div style={{ flexGrow: 1, display: "flex", flexDirection: isSmallDevice ? "column" : "row", alignItems: isSmallDevice ? "flex-start" : "center", gap: 20, flexWrap: "wrap" }}>
                            <div>
                                <div className='reportsFieldLabels'>Report Type</div>
                                <FormControl className={classes.formControl} variant="outlined" size="small" style={{ width: 180 }}>
                                    <Select
                                        value={reportType.type}
                                        onChange={event => {
                                            setReportType(REPORT_TYPES.find(val => val.type === event.target.value))
                                            setFilterListValue(null)
                                        }}
                                        style={{ color: "#555", textTransform: "capitalize" }}
                                    >
                                        {REPORT_TYPES.filter(type => type.visible).map(reportType => (
                                            <MenuItem className="customSelectStyle" value={reportType.type} style={{ textTransform: "capitalize" }}>{reportType.type.replaceAll("_", " ").toLowerCase()}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>

                            <div>
                                <div>
                                    <div className='reportsFieldLabels'>File Format</div>
                                    <div>
                                        <FormGroup row style={{ gap: 20 }}>
                                            {REPORT_FORMATS.map((format, i) => (
                                                <div className='addBorderRadius' key={i} style={{ backgroundColor: "#F5F8FA", padding: "0px 20px", height: 44 }}>
                                                    <FormControlLabel
                                                        key={format.value}
                                                        control={
                                                            <Checkbox
                                                                checked={format.value === selectedFormat}
                                                                onChange={() => handleReportFormatChange(format.value)}
                                                            />
                                                        }
                                                        label={<span className='fontWeightMedium' style={{ color: "#334D6E", fontSize: 12 }}>{format.label}</span>}
                                                    />
                                                </div>
                                            ))}
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                                {filterTypesInitState && (
                                    <div>
                                        <div className='reportsFieldLabels'>Filters</div>
                                        <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} />
                                    </div>
                                )}
                            </div>
                            <div>{!HIDE_TIME_PERIOD.includes(reportType.type) &&
                                <div>
                                    <div className='reportsFieldLabels' style={{ opacity: 0 }}>Time Period</div>
                                    <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime}/>
                                </div>
                            }</div>
                        </div>

                        <div>
                            <div style={{ fontFamily: "Poppins-Regular", color: "#334D6E", marginBottom: 5, fontWeight: 600, fontSize: 13, opacity: 0 }}>Button</div>
                            <Button
                                className='addBorderRadius'
                                onClick={generateReport}
                                color="primary"
                                variant="contained"
                                style={{ textTransform: "none", fontSize: 12, fontFamily: "Poppins-SemiBold", letterSpacing: "0.06em", height: "42px", minWidth: "120px", backgroundColor: "#18CC69", color: "#FFF", paddingLeft: 35, paddingRight: 35 }}
                                disableElevation
                                disabled={requestReportLoading}
                            >
                                Generate {requestReportLoading ? <CircularProgress size={22} /> : <ArrowForwardIosIcon style={{ fontSize: 16, marginLeft: 25 }} />}
                            </Button>
                        </div>
                    </div>
                </div>

                {(currentTab === GENERATE_REPORTS) &&
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 35, marginBottom: 10 }}>
                        <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                        <RefreshIconButton size={25} color="primary" />
                    </div>
                }

                <List
                    {...props}
                    basePath='/reports'
                    title="Recent Reports"
                    bulkActionButtons={false}
                    exporter={false}
                    filter={filter}
                    empty={false}
                    pagination={<CustomPagination />}
                    actions={false}
                    sort={{ field: "requested_on", order: "DESC" }}
                >
                    {isSmallDevice ?
                        <SimpleList
                            primaryText={record => <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                                <div style={{ textTransform: "capitalize" }}>{record.name.replaceAll("_", " ").toLowerCase()}</div>
                                <div style={{ fontFamily: "Poppins-Regular", fontSize: 14, color: "#666" }}>{record.file_type}</div>
                            </div>}
                            secondaryText={record => (<div>
                                <div><ReportParkings record={record} source="report_parkings" label="Parkings" /></div>
                                {record && record.report_start_time && <div><span style={{ color: "#5a5a5a" }}>From: </span>{renderTime(record.report_start_time)}</div>}
                                {record && record.report_end_time && <div><span style={{ color: "#5a5a5a" }}>To: </span>{renderTime(record.report_end_time)}</div>}
                                <div style={{ fontSize: 13, color: "#888" }}>Requested {moment(record.requested_on).fromNow()}</div>
                                {record.status === "COMPLETED" ?
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <IconButton color="secondary" onClick={() => download(record.file_url)}><DownloadIcon /></IconButton>
                                        <div style={{ display: "flex", alignItems: "center", gap: 5, marginLeft: 8 }}>
                                            <InfoOutlinedIcon style={{ fontSize: 15, color: "#888" }} />
                                            <div style={{ fontFamily: "Poppins-Regular", fontSize: 12 }}>Expires {moment(record.updated_on).add(2, "days").fromNow()}</div>
                                        </div>
                                    </div>
                                    : record.status === "ERROR" ?
                                        <div style={{ display: "flex", color: "#e99100" }}>
                                            <div>{record.remarks}</div>
                                        </div>
                                        :
                                        <div style={{ marginTop: 20 }}>
                                            <div style={{ display: "flex" }}>
                                                <Tooltip arrow title={record.remarks} classes={{ tooltip: classes.tooltip }} placement="bottom-start">
                                                    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                        <Button color="secondary" variant="text" startIcon={<ReplayIcon />} onClick={() => refresh()}>Refresh</Button>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            <div className={classes.tooltip}>{record.remarks}</div>
                                        </div>
                                }
                            </div>)}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid className='customStyleDataGrid' component={ScrollableTable}>
                            <FunctionField source="name" label="Report Type" render={record => <div style={{ textTransform: "capitalize", color: "#707683", fontWeight: 600 }}>{record.name.replaceAll("_", " ").toLowerCase()}</div>} sortable />
                            <FunctionField source="requested_on" label="Requested At" render={record => record && record.requested_on ?
                                <div>
                                    <div style={{ color: "#707683", fontWeight: 600 }}>{moment(record.requested_on).format("hh:mm A")}</div>
                                    <div style={{ color: "#AAAAAA" }}>{moment(record.requested_on).format("DD/MM/YYYY")}</div>
                                </div>
                                : "-"
                            }
                            />

                            <FunctionField source="file_type" label="Format" style={{ fontFamily: "Poppins-SemiBold" }} render={record => record && record.file_type === 'xlsx' ? 'Excel' : record && record.file_type === 'pdf' ? 'PDF' : '-'} />
                            <FunctionField source="report_start_time" label="Start Time" render={record => record && record.report_start_time ?
                                <div>
                                    <div style={{ color: "#707683", fontWeight: 600 }}>{moment(record.report_start_time).format("hh:mm A")}</div>
                                    <div style={{ color: "#AAAAAA" }}>{moment(record.report_start_time).format("DD/MM/YYYY")}</div>
                                </div>
                                : "-"
                            }
                            />

                            <FunctionField source="report_end_time" label="End Time" render={record => record && record.report_end_time ?
                                <div>
                                    <div style={{ color: "#707683", fontWeight: 600 }}>{moment(record.report_end_time).format("hh:mm A")}</div>
                                    <div style={{ color: "#AAAAAA" }}>{moment(record.report_end_time).format("DD/MM/YYYY")}</div>
                                </div>
                                : "-"
                            }
                            />
                            <FunctionField source="filters" label="Filters" render={record => record && record.filters ? record.filters : '-'} />
                            {/* <ReportParkings source="report_parkings" label="Parkings" /> */}
                            <FunctionField source="updated_on" label="Expiry" render={record => record && record.updated_on ?
                                <div>
                                    <div style={{ color: "#707683", fontWeight: 600 }}>{moment(record.updated_on).add(2, "days").format("hh:mm A")}</div>
                                    <div style={{ color: "#AAAAAA" }}>{moment(record.updated_on).add(2, "days").format("DD/MM/YYYY")}</div>
                                </div>
                                : "-"
                            }
                            />
                            <FunctionField
                                source="status"
                                label="Status"
                                render={record => (
                                    record.status === "COMPLETED" ?
                                        <Button onClick={() => { if (!moment(record.updated_on).add(2, "days").isBefore(moment())) download(record.file_url) }} color="primary" variant="contained" style={{ textTransform: "none", fontSize: 12, fontFamily: "Poppins-SemiBold", letterSpacing: "0.06em", height: "28px", minWidth: "120px", backgroundColor: moment(record.updated_on).add(2, "days").isBefore(moment()) ? "#F7685B" : "#18CC69", color: "#FFF", borderRadius: 5 }} disableElevation>
                                            {moment(record.updated_on).add(2, "days").isBefore(moment()) ? "Expired" : "Download"}
                                        </Button>
                                        : record.status === "ERROR" ?
                                            <div style={{ display: "flex", color: "#e99100" }}>
                                                <div>{record.remarks}</div>
                                            </div>
                                            :
                                            <Button variant="contained" style={{ backgroundColor: "#E5CE00", textTransform: "none", fontSize: 12, fontFamily: "Poppins-SemiBold", letterSpacing: "0.06em", height: "28px", minWidth: "120px", color: "#FFF", borderRadius: 5 }} disableElevation>
                                                Processing
                                            </Button>

                                )}
                            />
                        </Datagrid>
                    }
                </List>
            </ResourceContextProvider>
        }
        {currentTab === SCHEDULED_REPORTS &&
            <ResourceContextProvider value="scheduledReports">
                <div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>

                        <div style={{ flex: "0 0 49%" }}>
                            <div className='reportsFieldLabels' style={{ marginTop: 10 }}>Email IDs</div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <MuiTextField
                                    className={classes.textField}
                                        type="email"
                                        value={newEmail}
                                        inputRef={inputRef}
                                        onBlur={handleBlur}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                addEmail();
                                            }
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        noOptionsText="NO Email"
                                        InputProps={{
                                            startAdornment: (
                                                <div style={{ display: 'flex', gap: '4px', marginTop: '4px' }}>
                                                    {emailList.map((email, index) => (
                                                        <Chip
                                                            key={index}
                                                            label={email}
                                                            onDelete={() => removeEmail(email)}
                                                            style={{ marginRight: '4px', marginBottom: '4px' }}
                                                        />
                                                    ))}
                                                </div>
                                            ),
                                        }}
                                    />
                                </div>
                            </div></div>

                        <div style={{ flex: "0 0 49%" }}>
                            <div className='reportsFieldLabels' style={{ marginTop: 10 }}>Select Site</div>
                            <div style={{ display: "flex", flexDirection: isSmallDevice ? "column" : "row", alignItems: isSmallDevice ? "flex-start" : "center", gap: 20, marginTop: 5, marginRight: 30, width: "100%" }}>
                                <Autocomplete
                                className={classes.autocomplete}
                                    multiple
                                    limitTags={4}
                                    value={selectedParkings}
                                    onChange={(event, parkings) => {
                                        setSelectedParkings(parkings);
                                        let zones = [];
                                        for (let p of parkings) {
                                            zones = zones.concat(JSON.parse(p.zones_obj));
                                        }
                                        setAllZones(zones);
                                        setSelectedZones(zones.filter(zone => zone.selected !== false));
                                    }}
                                    options={parkingSuggestions}
                                    getOptionLabel={option => option.general_name}
                                    //getOptionSelected={(option, value) => option.id === value.id}
                                    disableCloseOnSelect
                                    loading={loadingParkings}
                                    noOptionsText="No Parkings Found"
                                    onInputChange={handleParkingFilterChange}
                                    renderInput={params => <MuiTextField {...params} variant="outlined" />}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            {option.general_name}
                                        </React.Fragment>
                                    )}
                                    style={{ flex: 1, width: "100%" }}
                                />

                                {/*<div style={{ display: "flex", alignItems: "center", gap: 10, visibility: allZones.length > 0 ? "visible" : "hidden" }}>
                            <div style={{ fontFamily: "Poppins-Regular", color: "#222" }}>{selectedZones.length}/{allZones.length} Zones Selected</div>
                            <div onClick={() => setZoneEditDialogVisible(true)} style={{ display: "flex", alignItems: "center", gap: 3, color: "#4059de", textDecoration: "underline", cursor: "pointer" }}>
                                <EditIcon style={{ fontSize: 17 }} />
                                <div style={{ fontFamily: "Poppins-Regular" }}>Edit</div>
                            </div>
                            </div>*/}

                                <Dialog fullWidth open={zoneEditDialogVisible} onClose={closeZoneEditDialog} scroll="paper" classes={{ paper: classes.dialogPaper }}>
                                    <div style={{ fontFamily: "Poppins-Medium", fontSize: 18, color: "#222", padding: "10px 28px" }}>{selectedZones.length}/{allZones.length} Zones Selected</div>
                                    <DialogContent dividers style={{ padding: 0 }}>
                                        <ListItem key="select_all" button onClick={selectAllZones} style={{ padding: "4px 30px" }}>
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={selectedZones.length === allZones.length}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Select All" classes={{ primary: classes.boldText }} />
                                        </ListItem>
                                        {allZones.map((zone, index) => (
                                            <ListItem key={zone.id} button onClick={() => toggleZoneSelection(zone, index)} style={{ padding: "4px 30px" }}>
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={zone.selected !== false}
                                                        disableRipple
                                                    />
                                                </ListItemIcon>
                                                <ListItemText primary={zone.name} classes={{ primary: classes.lightText }} />
                                            </ListItem>
                                        ))}
                                    </DialogContent>
                                    <DialogActions style={{ marginTop: 20 }}>
                                        <Button
                                            onClick={closeZoneEditDialog}
                                            color="primary"
                                            variant="contained"
                                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18CC69", color: "#FFF" }}
                                            disableElevation
                                        >
                                            Okay
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div></div>
                    </div>

                    <div style={{ display: "flex", flexDirection: isSmallDevice ? "column" : "row", alignItems: isSmallDevice ? "flex-start" : "center", gap: 20, marginTop: 25 }}>

                        <div>
                            <div className='reportsFieldLabels'>Report Type</div>
                            <FormControl className={classes.formControl} variant="outlined" size="small" style={{ width: 180 }}>
                                <Select
                                    value={reportType.type}
                                    onChange={event => {
                                        setReportType(REPORT_TYPES.find(val => val.type === event.target.value))
                                        setFilterListValue(null)
                                    }}
                                    style={{ color: "#555", textTransform: "capitalize" }}
                                >
                                    {REPORT_TYPES.filter(type => type.visible).map(reportType => (
                                        <MenuItem className="customSelectStyle" value={reportType.type} style={{ textTransform: "capitalize" }}>{reportType.type.replaceAll("_", " ").toLowerCase()}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div>
                            <div>
                                <div className='reportsFieldLabels'>File Format</div>
                                <FormGroup row style={{ gap: 20 }}>
                                    {REPORT_FORMATS.map((format, i) => (
                                        <div className='addBorderRadius' key={i} style={{ backgroundColor: "#F5F8FA", padding: "0px 20px", height: 44 }}>
                                            <FormControlLabel
                                                key={format.value}
                                                control={
                                                    <Checkbox
                                                        checked={selectedMultipleFormat.includes(format.value)}
                                                        onChange={() => handleMultipleReportFormatChange(format.value)}
                                                    />
                                                }
                                                label={<span className='fontWeightMedium' style={{ color: "#334D6E", fontSize: 12 }}>{format.label}</span>}
                                            />
                                        </div>
                                    ))}
                                </FormGroup>
                            </div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                            {filterTypesInitState && (
                                <div>
                                    <div className='reportsFieldLabels'>Filters</div>
                                    <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} />
                                </div>
                            )}
                        </div>
                        <div>
                            <div className='reportsFieldLabels'>Frequency</div>
                            <FormControl className={classes.formControl} variant="outlined" size="small" style={{ width: 100 }}>
                                <Select
                                    value={frequencyType.type}
                                    onChange={(event) => {
                                        setFrequencyType(FREQUENCY_TYPES.find((val) => val.type === event.target.value));
                                    }}
                                    style={{ color: '#555', textTransform: 'capitalize', }}>
                                    {FREQUENCY_TYPES.map((frequencyType) => (
                                        <MenuItem className="customSelectStyle" value={frequencyType.type} style={{ textTransform: 'capitalize' }}>
                                            {frequencyType.type}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <div style={{}}>
                                    {frequencyType.type === 'Daily' &&
                                        <div>
                                            <div className='reportsFieldLabels'>Time</div>
                                            <TimePicker
                                                margin="normal"
                                                id="time-picker"
                                                label=""
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                                style={{ maxWidth: 100 }}
                                                value={selectedTime}
                                                onChange={handleTimeChange}
                                            />
                                        </div>
                                    }

                                    {frequencyType.type === 'Weekly' &&
                                        <div style={{ display: "flex" }}>
                                            <div>
                                                <div className='reportsFieldLabels'>Date</div>
                                                <TimePicker
                                                    margin="normal"
                                                    id="time-picker"
                                                    label=""
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change time',
                                                    }}
                                                    style={{ maxWidth: 100 }}
                                                    value={selectedTime}
                                                    onChange={handleTimeChange}
                                                />
                                            </div>
                                            <div style={{ marginLeft: 20 }}>
                                                <div className='reportsFieldLabels'>Day</div>
                                                <FormControl className={classes.formControl} variant="outlined" size="small" style={{ width: 100 }}>
                                                    <Select
                                                        value={selectedDay}
                                                        onChange={handleDayChange}
                                                        style={{ color: '#555', textTransform: 'capitalize' }}
                                                    >
                                                        {DAYS_OF_WEEK.map((day) => (
                                                            <MenuItem className="customSelectStyle" key={day} value={day} style={{ textTransform: 'capitalize' }}>
                                                                {day}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>}

                                    {frequencyType.type === 'Monthly' &&
                                        <div style={{ display: "flex" }}>
                                            <div>
                                                <div className='reportsFieldLabels'>Time</div>
                                                <TimePicker
                                                    margin="normal"
                                                    id="time-picker"
                                                    label=""
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change time',
                                                    }}
                                                    style={{ maxWidth: 100 }}
                                                    value={selectedTime}
                                                    onChange={handleTimeChange}
                                                />
                                            </div>
                                            <div style={{ marginLeft: 20 }}>
                                                <div className='reportsFieldLabels'>Date</div>
                                                <FormControl className={classes.formControl} variant="outlined" size="small" style={{ width: 100 }}>
                                                    <Select
                                                        value={selectedDate}
                                                        onChange={handleDateChange}
                                                        style={{ color: '#555' }}
                                                    >
                                                        {datesArray.map((date) => (
                                                            <MenuItem className="customSelectStyle" key={date} value={date}>
                                                                {date}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <Button
                            className='addBorderRadius'
                            onClick={scheduleReport}
                            color="primary"
                            variant="contained"
                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18CC69", color: "#FFF" }}
                            disableElevation
                            disabled={requestReportLoading}
                        >
                            Schedule Report {requestReportLoading ? <CircularProgress size={22} /> : <ArrowForwardIosIcon style={{ fontSize: 16, marginLeft: 25 }} />}
                        </Button>
                    </div>

                    {<div className='reportsFieldLabels' style={{ marginTop: 10 }}>
                        {frequencyType.type === 'Daily' && <div>Next report generated from {showStartTime ? showStartTime.toString() : "-"} - {showEndTime ? showEndTime.toString() : "-"}</div>}
                        {frequencyType.type === 'Weekly' && <div>Next report generated from {showStartTime ? showStartTime.toString() : "-"} - {showEndTime ? showEndTime.toString() : "-"}</div>}
                        {frequencyType.type === 'Monthly' && <div>Next report generated from {showStartTime ? showStartTime.toString() : "-"} - {showEndTime ? showEndTime.toString() : "-"}</div>}
                    </div>}
                </div>

                {(currentTab === SCHEDULED_REPORTS) &&
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 10 }}>
                        <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                        <RefreshIconButton size={25} color="primary" />
                    </div>
                }

                <List
                    {...props}
                    style={{ marginTop: 10 }}
                    resource="scheduledReports"
                    basePath="/scheduledReports"
                    title="Scheduled Reports"
                    bulkActionButtons={false}
                    exporter={false}
                    filter={filter}
                    empty={false}
                    pagination={<CustomPagination />}
                    actions={false}
                    sort={{ field: "created_on", order: "DESC" }}
                >
                    {isSmallDevice ?
                        <SimpleList
                            primaryText={record => record.name}
                            secondaryText={record => (<div>
                                {record.file_types && <div><span style={{ color: "#5a5a5a" }}>Format: </span>{renderField(record.file_types)}</div>}
                                {record.frequency && <div><span style={{ color: "#5a5a5a" }}>Frequency: </span>{record.frequency}</div>}
                                {record.start_time && <div><span style={{ color: "#5a5a5a" }}>Report Start Time: </span>{record.start_time ? convertTo12HourFormat(record.start_time) : "-"}</div>}
                                {record.start_day_of_week && <div><span style={{ color: "#5a5a5a" }}>Start Day: </span>{record.start_day_of_week ? record.start_day_of_week : "-"}</div>}
                                {record.report_parkings && <div><span style={{ color: "#5a5a5a" }}>Parkings: </span>{getArrayLength(record.report_parkings)}</div>}
                                {record.email && <div><span style={{ color: "#5a5a5a" }}>Emails: </span>{getArrayLength(record.email)}</div>}
                            </div>)}
                            rightIcon={record => (
                                <div>
                                    {/*<EditButton {...props} record={record} title="Edit" label={false} />*/}
                                    <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/scheduledReports'} />
                                </div>
                            )}
                            onContextMenu={event => event.preventDefault()}
                            linkType={false}
                            rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                        />
                        :
                        <Datagrid className='scheduledReportsDataGrid' component={ScrollableTable}>
                            <ScheduleToggler label={false} source="enabled" />
                            <FunctionField source="name" label="Schedule Type" render={record => <div style={{ textTransform: "capitalize", fontFamily: "Poppins-SemiBold", color: "#555" }}>{record.name.replaceAll("_", " ").toLowerCase()}</div>} sortable />
                            <FunctionField source="file_types" label="Format" render={record => record && renderField(record.file_types)} />
                            <TextField source="frequency" label="Frequency" />
                            <FunctionField source="start_time" label="Report Start Time" render={record => record && record["start_time"] ? convertTo12HourFormat(record.start_time) : '-'} />
                            <FunctionField source="start_day_of_week" label=" Start Day" render={record => record && record["start_day_of_week"] ? record["start_day_of_week"] : '-'} />
                            <FunctionField source="start_date" label=" Start Date" render={record => record && record["start_date"] ? record["start_date"] : '-'} />
                            <FunctionField source="report_parkings" label="Parkings" render={record => record && getArrayLength(record.report_parkings)} />
                            <FunctionField source="email" label="Emails" render={record => record && getArrayLength(record.email)} />
                            <FunctionField source="updated_on" label="Updated At" render={record => moment(record.created_on).format("YYYY-MM-DD HH:mm:ss")} sortable />
                            <FunctionField className="ListIconsContainerScheduledReports" render={record => record &&
                                <div className="ListIcons">
                                    <div>
                                        {/*<EditButton {...props} record={record} />*/}
                                        <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/scheduledReports'} />
                                    </div>
                                </div>
                            } />
                        </Datagrid>
                    }
                </List>
            </ResourceContextProvider>
        }
    </div>
};




function ReportParkings(props) {
    const { record, source } = props;
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    if (!record || !record[source])
        return null;

    const parkings = JSON.parse(record[source])

    return (
        <div style={{ textAlign: "left", display: "block", alignItems: "center", flex: 1 }}>
            {isSmallDevice ?
                <div onClick={openDialog} style={{ fontFamily: "Poppins-SemiBold", fontSize: 14, color: customTheme.palette.secondary.main, cursor: "pointer" }}>{parkings.length} Parkings</div>
                :
                <IconButton style={{ width: 40, height: 40, fontSize: 16, color: customTheme.palette.secondary.main }} onClick={openDialog}>{parkings.length}</IconButton>
            }

            <Dialog fullWidth open={dialogVisible} onClose={closeDialog} PaperProps={{ style: { maxWidth: 400 } }}>
                {parkings.map(parking => (
                    <ListItem>
                        <ListItemIcon><EmojiTransportationOutlinedIcon /></ListItemIcon>
                        <ListItemText style={{ marginLeft: 10 }} primary={parking} />
                    </ListItem>
                ))}
            </Dialog>
        </div>
    );
}

function ScheduleToggler(props) {
    const classes = useStyles()
    const { record } = props;
    const isSmallDevice = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const refresh = useRefresh();

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const handleUpdate = (event) => {
        event.preventDefault();
        fetch(`${config.HOST_NAME}/crm/v3/scheduledReports/${record.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ user_id: sessionStorage.getItem("user_id"), id: record.id, enabled: Boolean(record.enabled) === true ? 0 : 1 })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (!json.success) notify(json.message, 'warning');
                else {
                    refresh()
                }
            })
            .catch(error => {
                notify('Error updating record', 'warning');
            })
            .finally(() => {
                closeDialog()
            })
    };

    if (!record) return null
    return (
        <div style={{ textAlign: "left", display: isSmallDevice ? "flex" : "block", alignItems: "center", flex: 1 }}>
            {isSmallDevice && <div>Enable Scheduler:</div>}
            <AntSwitch checked={Boolean(record.enabled)} onChange={openDialog} />

            <Dialog open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
                <DialogContent>
                    <p>Are you sure you want to <strong>{record.enabled ? "Disable" : "Enable"}</strong> this Scheduler?</p>
                </DialogContent>
                <DialogActions>
                    <Button color="default" onClick={closeDialog}>No</Button>
                    <Button color="secondary" onClick={handleUpdate}>Yes</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}


const AntSwitch = withStyles((theme) => ({
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[500],
        '&$checked': {
            transform: 'translateX(12px)',
            color: theme.palette.common.white,
            '& + $track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 11,
        height: 11,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
        height: "auto",
        paddingTop: 2,
        paddingBottom: 2
    },
    checked: {},
}))(Switch);